import React from "react"
import { alertShow } from "../config/Helpers";

class Alerts extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            rows_models  : "",
            rows_reports : ""
        }
    }

    handleClick(type){
        this.props.alertState(type)
    }
    render(){
        return (
            <div className={"container-alerts " + alertShow(this.props)}>
                <div className={"alert-datepicker-error " + this.props.alert_datepicker_error}>
                    <p className="title">Error dates</p>
                    <p>Select a range of dates</p>
                    <a onClick={this.handleClick.bind(this,"datepicker")} href="#">Close</a>
                </div>
                <div className={"alert-datepicker-error " + this.props.alert_demo_version}>
                    <p className="title">Invalid function</p>
                    <p>Not available in demo version</p>
                    <a onClick={this.handleClick.bind(this,"demo_version")} href="#">Close</a>
                </div>
                <div className={"alert-datepicker-error " + this.props.alert_error_network}>
                    <p className="title">A network error has occurred</p>
                    <p>Something went wrong while the request was made</p>
                    <a onClick={() => { window.location.reload(); }} href="#">Reload</a>
                </div>
            </div>
        )
    }
}

export default Alerts


// WEBPACK FOOTER //
// ./src/Frontend/components/Alerts.js